import React, { useState, useEffect, Fragment } from 'react';
import services from '../services';
import { ignoreSessionSchemaObject } from '../ignoreSessionSchema';
import { Fields, validateProperty, validate, Card } from "../../Common"
import MessageModal from '../../../UI/Modal/MessageModal';
import Joi from '@hapi/joi'
import { PageHeader } from '../../../Common';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import FormHelperText from '@material-ui/core/FormHelperText';
import { LoadingSpinerComponent } from '../../../Common/loader'
import { trackPromise } from 'react-promise-tracker';
import authService from '../../Common/services';

import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Typography from '@material-ui/core/Typography';
import { element } from 'prop-types';
import { functions } from 'lodash';
import tokenService from '../../../Common/tokenDecoder';

const screenCode = 'IGNORESESSION';

export function IgnoreSessionAddEdit(props) {

    const { data, edit } = props.location
    const [title, setTitle] = useState("Add IgnoreSession")
    const [groups, setGroups] = useState()
    const [estates, setEstates] = useState()
    const [devisions, setDevisions] = useState()
    const [ignoreSession, setIgnoreSession] = useState({
        groupID: "0",
        operationEntityID: "0",
        collectionPointID: "0",
        registrationNumber: '',
        searchDate: '',
        reason: ''
    });
    const [buttonName, setButtonName] = useState("Save");
    const [errors, setErrors] = useState({})
    const [messageModel, setMessageModel] = useState({
        hidden: true,
        type: "Success",
        disciption: "Save/ Edit success"
    })

    const [pageProperties, setPageProperties] = useState({
        title: 'Add IgnoreSession',
        submitButtonName: 'Save'
    })
    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false
    });

    const schema = Joi.object(ignoreSessionSchemaObject).options({ allowUnknown: true })

    useEffect(() => {
        getPermissions();
    }, []);


    useEffect(() => {
        trackPromise(
            getEstates()
        )
    }, [ignoreSession.groupID])

    useEffect(() => {
        trackPromise(
            getDevisions()
        )
    }, [ignoreSession.operationEntityID])

    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);

        var isAuthorized = permissions.find(p => p.permissionCode == 'ADDEDITIGNORESESSION');

        if (isAuthorized === undefined) {
            props.history.push('/unauthorized');
        }
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');

        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled: isOperationEntityFilterEnabled !== undefined
        });

            
            setTitle("Add IgnoreSession");
            var token = tokenService.getUserDetailsFromToken();
            setIgnoreSession({
                ...ignoreSession,
                groupID: token.groupID,
                operationEntityID: token.operationEntityID
            });
        

        trackPromise(
            getAllGroups()
        )
    }

    async function setDevisionForEdit() {
        const result = await services.getDivisions(data.operationEntityID)
        setDevisions(result)
    }

    function handleGroupChange(target) {
        validateInputs(target);

        setIgnoreSession({
            ...ignoreSession,
            groupID: target.value,
            operationEntityID: '0',
            collectionPointID:'0'
        })
    }

    function handleOperationEntityChange(target) {
        validateInputs(target);

        setIgnoreSession({
            ...ignoreSession,
            operationEntityID: target.value,
            collectionPointID: '0'
        })
    }

    function handleCollectionPointChange(target) {
        validateInputs(target);

        setIgnoreSession({
            ...ignoreSession,
            collectionPointID: target.value
        })
    }
    function handleIgnoreSessionNameChange(target) {
        validateInputs(target);
        setIgnoreSession({
            ...ignoreSession,
            ignoreSessionName: target.value
        })
    }
    function handleIgnoreSessionCodeChange(target) {
        validateInputs(target);
        setIgnoreSession({
            ...ignoreSession,
            ignoreSessionCode: target.value
        })
    }

    function handleActiveChange(target) {
        validateInputs(target);

        setIgnoreSession({
            ...ignoreSession,
            isActive: target.checked
        })
    }

    function handleSearchDateChange(target) {
        validateInputs(target);

        setIgnoreSession({
            ...ignoreSession,
            searchDate: target.value
        });
    }

    function validateInputs(target) {
        const error = { ...errors };
        const errorMessage = validateProperty(target, ignoreSessionSchemaObject);
        errorMessage ? error[target.name] = errorMessage : delete error[target.name];

        setErrors(error)
    }

    function handleChange(e) {
        const target = e.target
        const value = (target.name === 'isActive' || target.name === 'isErpEnabled') ? target.checked : target.value

        const error = { ...errors }
        const errorMessage = validateProperty(target, ignoreSessionSchemaObject)
        errorMessage ? error[target.name] = errorMessage : delete error[target.name]
        

        setIgnoreSession({
            ...ignoreSession,
            [e.target.name]: value
        })

        setErrors(error)
    }

    async function handleSave(e) {
       
        const response = await services.saveIgnoreSession(ignoreSession.collectionPointID,ignoreSession.registrationNumber,ignoreSession.reason,ignoreSession.searchDate);
        setMessageModel({ ...messageModel, hidden: false, type: response.statusCode, disciption: response.message })
        afterSuccessfulyChanged(response.statusCode)
        

    }

    function afterSuccessfulyChanged(response) {

        if (response === "Success") {

            setTimeout(() => {
                props.history.push({ pathname: '/ignoreSession' })
            }, 1500);
        }
    }

    async function getEstates() {
        const result = await services.getEstatesByGroupID(ignoreSession.groupID)
        setEstates(result)
    }

    async function getAllGroups() {
        const result = await services.getGroups()
        setGroups(result)
    }

    async function getDevisions() {
        const result = await services.getDivisions(ignoreSession.operationEntityID)
        setDevisions(result)
    }
    function modalDismissHandler() {
        setMessageModel({ ...messageModel, hidden: true })
    }

    function generateDropDownMenu(data) {
        let items = []
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(<MenuItem key={key} value={key}>{value}</MenuItem>)
            }
        }
        return items
    }

    function clearButton() {
        setErrors({});
        var token = tokenService.getUserDetailsFromToken();
        setIgnoreSession({
            ...ignoreSession,
            groupID: !permissionList.isGroupFilterEnabled ? '0' : token.groupID,
            operationEntityID: !permissionList.isOperationEntityFilterEnabled ? '0' : token.operationEntityID,
            collectionPointID: 0,
            ignoreSessionName:'',
            ignoreSessionCode:'',
            isActive: true
        });
    }

    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="col-md-12">
                    <div className="card">
                        <div className="card-body">
                            <div className="row">
                                <PageHeader
                                    title={title}
                                    isButtonEnable={true}
                                    buttonText="Back to Listing"
                                    path="/ignoreSession"

                                />
                            </div>
                            <hr />

                            <form>

                                <div className="form-group row">
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="groupID">Group *</InputLabel>
                                        <Select
                                            fullWidth
                                            id="groupID"
                                            disabled={!permissionList.isGroupFilterEnabled}
                                            name="groupID"
                                            value={ignoreSession.groupID}
                                            onChange={(e) => handleGroupChange(e.target)}>
                                            <MenuItem value="0">--Select Group--</MenuItem>
                                            {generateDropDownMenu(groups)}
                                        </Select>
                                        {errors["groupID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["groupID"]}</FormHelperText>}
                                    </div>

                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="operationEntityID">Estate *</InputLabel>
                                        <Select
                                            fullWidth
                                            id="operationEntityID"
                                            disabled={!permissionList.isOperationEntityFilterEnabled}
                                            name="operationEntityID"
                                            value={ignoreSession.operationEntityID}
                                            onChange={(e) => handleOperationEntityChange(e.target)}>
                                            <MenuItem value="0">--Select Estate--</MenuItem>
                                            {generateDropDownMenu(estates)}
                                        </Select>
                                        {errors["operationEntityID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["operationEntityID"]}</FormHelperText>}
                                    </div>

                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="collectionPointID">Devision *</InputLabel>
                                        <Select
                                            fullWidth
                                            id="collectionPointID"
                                            name="collectionPointID"
                                            value={ignoreSession.collectionPointID}
                                            onChange={(e) => handleCollectionPointChange(e.target)}>
                                            <MenuItem value="0">--Select Devision--</MenuItem>
                                            {generateDropDownMenu(devisions)}
                                        </Select>
                                        {errors["collectionPointID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["collectionPointID"]}</FormHelperText>}
                                    </div>
                                </div>
                                
                                <div className="form-group row">

                                    
                                    <div className="col-md">
                                        <TextField fullWidth label="Registration Number"
                                            name="registrationNumber"
                                            id="registrationNumber"
                                            value={ignoreSession.registrationNumber}
                                            type="number"
                                            onChange={(e) => handleChange(e)} />
                                            {errors["registrationNumber"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["registrationNumber"]}</FormHelperText>)}
                                    </div>
                                    <div className="col-md-4">
                                        <InputLabel shrink id="searchDate">Effective Date *</InputLabel>
                                        <TextField
                                            fullWidth
                                            id="searchDate"
                                            name="searchDate"
                                            type="date"
                                            onChange={(e) => handleSearchDateChange(e.target)}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                        {errors["searchDate"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["searchDate"]}</FormHelperText>)}
                                    </div>

                                    <div className="col-md-4">
                                        <TextField fullWidth label="Reason*"
                                            name="reason"
                                            id="reason"
                                            value={ignoreSession.reason}
                                            type="text"
                                            onChange={(e) => handleChange(e)} />
                                        {errors["reason"] && <span id="errbranchCode" className="text text-danger">{errors["reason"]}</span>}
                                    </div>
                                    
                                </div>

                               

                                
                                <MessageModal
                                    hidden={messageModel.hidden}
                                    messageType={messageModel.type}
                                    messageDescription={messageModel.disciption}
                                    clicked={modalDismissHandler}
                                />

                                <div className="card-footer">
                                    <input
                                        type="button"
                                        className="btn btn-primary"
                                        value={buttonName}
                                        onClick={handleSave}
                                    />
                                    <input
                                        type="reset"
                                        className="btn btn-warning pull-right"
                                        value="Clear"
                                        onClick={clearButton}
                                    />
                                </div>
                            </form>

                        </div>
                    </div>
                </div>
            </div>
            <MessageModal
                hidden={messageModel.hidden}
                messageType={messageModel.type}
                messageDescription={messageModel.disciption}
                clicked={modalDismissHandler}
            />
        </Fragment>
    );
}